export default {
    "waitEvaluate": ["isManager", "isInspector"],
    "waitSubmit": ["isManager", "isInspector"],
    "waitConfirm": ["isManager", "isAgent", "isInspector"],
    "waitReview": ["isManager", "isReview"],
    "completed": ["isManager", "isInspector", "isReview"],
    "entiretyReport": ["overall"],
    "serviceGroupReport": ["allAgentGroup", "agentGroup"],
    "serviceReport": ["allAgent", "personalAgent"]
};